import React from 'react'
import WebPushUtil from "../../../../util/WebPushUtil";
import {BREITE_TABLET, useSchmaleAnsicht, vorhanden} from "./statistikWerte";

/**
 * Teilnehmer des Events im neuen Design, mit Warteliste. Beim Ligaspieltag (ligaspieltag=true) getrennt
 * nach Heim- und Gastverein. Die alte Ansicht verwendet weiterhin PublicTournamentParticipantTab
 * bzw. PublicTournamentLigaspieltagParticipantTab.
 * Gesucht wird über die Spielersuche der Seite, daher gibt es hier kein eigenes Suchfeld.
 */
export default function TeilnehmerBereich({tournamentId, participants, tournamentGroupEntities, maxAnzahlTeilnehmer, playersSortedByTime,
                                              isBezahlung, isParticipantsMailConfirmation, ligaspieltag,
                                              supportsWebPush, pushSpielerIds, updateSubscriptions}) {

    if (ligaspieltag) {
        // Doppel (idShortSinglePlayer1 gesetzt) werden wie in der alten Ansicht nicht aufgeführt
        const einzel = participants.filter(player => !vorhanden(player.idShortSinglePlayer1));
        const heim = einzel.filter(player => player.heimmannschaft);
        const gast = einzel.filter(player => !player.heimmannschaft);
        return <div className="dhpt-statistik">
            <TeilnehmerKarte titel="Heimverein" zusatz={heim.length + " Teilnehmer"} teilnehmer={heim}/>
            <TeilnehmerKarte titel="Gastverein" zusatz={gast.length + " Teilnehmer"} teilnehmer={gast}/>
        </div>
    }

    const teilnehmer = participants.filter(player => !player.warteliste);
    const warteliste = (playersSortedByTime || []).filter(player => player.warteliste);
    const status = {
        bestaetigung: isParticipantsMailConfirmation,
        bezahlung: isBezahlung,
        push: supportsWebPush,
        pushSpielerIds: pushSpielerIds || [],
        onPush: (spielerId, aktivieren) => {
            if (aktivieren) {
                WebPushUtil.pushAktivieren(tournamentId, spielerId);
            } else {
                WebPushUtil.pushDeaktivieren(tournamentId, spielerId);
            }
            updateSubscriptions();
        },
    };
    const gruppen = tournamentGroupEntities && tournamentGroupEntities.length > 0 ? tournamentGroupEntities : undefined;

    const kennzahl = (wert, bezeichnung) => <div className="dhpt-kennzahl"><b>{wert}</b><small>{bezeichnung}</small></div>;

    return <div className="dhpt-statistik">
        <div className="dhpt-kennzahlen">
            {kennzahl(teilnehmer.length, "Teilnehmer")}
            {vorhanden(maxAnzahlTeilnehmer) && kennzahl(maxAnzahlTeilnehmer, "max. Teilnehmer")}
            {warteliste.length > 0 && kennzahl(warteliste.length, "auf der Warteliste")}
            {isBezahlung && kennzahl(teilnehmer.filter(player => player.bezahlt).length, "bezahlt")}
        </div>
        {(isParticipantsMailConfirmation || isBezahlung || supportsWebPush) &&
            <ul className="dhpt-tn-legende">
                {isParticipantsMailConfirmation && <li><i className="pi pi-check-circle dhpt-tn-ok" aria-hidden="true"/>Teilnahme bestätigt</li>}
                {isBezahlung && <li><i className="pi pi-euro dhpt-tn-ok" aria-hidden="true"/>Startgeld bezahlt</li>}
                {supportsWebPush && <li><i className="pi pi-star" aria-hidden="true"/>Benachrichtigung bei Spielen des Spielers</li>}
            </ul>
        }
        <TeilnehmerKarte titel="Teilnehmer" teilnehmer={teilnehmer} gruppen={gruppen} status={status}/>
        {warteliste.length > 0 &&
            <TeilnehmerKarte titel="Warteliste" zusatz="in der Reihenfolge der Anmeldung" teilnehmer={warteliste} status={status}/>
        }
    </div>
}

function istBestaetigt(player) {
    return !vorhanden(player.confirmationExpirationTime);
}

function TeilnehmerKarte({titel, zusatz, teilnehmer, gruppen, status}) {
    const getGruppe = (playerId) => {
        const eintrag = gruppen.find(tmp => tmp.spieler === playerId);
        return eintrag && eintrag.gruppe ? eintrag.gruppe : undefined;
    }
    const mitStatus = status !== undefined && (status.bestaetigung || status.bezahlung || status.push);
    const schmal = useSchmaleAnsicht(BREITE_TABLET);

    const getStatus = (player) => {
        const bestaetigt = istBestaetigt(player);
        const push = status.pushSpielerIds.includes(player.id);
        return <span className="dhpt-tn-status">
            {status.bestaetigung &&
                <span className={bestaetigt ? "dhpt-tn-ok" : "dhpt-tn-offen"} title={bestaetigt ? "Teilnahme bestätigt" : "Teilnahme noch nicht bestätigt"}>
                    <i className={bestaetigt ? "pi pi-check-circle" : "pi pi-clock"} aria-hidden="true"/>
                    <span className="dhpt-st-versteckt">{bestaetigt ? "Teilnahme bestätigt" : "Teilnahme noch nicht bestätigt"}</span>
                </span>
            }
            {status.bezahlung &&
                <span className={player.bezahlt ? "dhpt-tn-ok" : "dhpt-tn-offen"} title={player.bezahlt ? "Bezahlt" : "Noch nicht bezahlt"}>
                    <i className="pi pi-euro" aria-hidden="true"/>
                    <span className="dhpt-st-versteckt">{player.bezahlt ? "Bezahlt" : "Noch nicht bezahlt"}</span>
                </span>
            }
            {status.push &&
                <button type="button" className="dhpt-tn-push" aria-pressed={push}
                        aria-label={"Benachrichtigung für " + player.name}
                        title={push ? "Benachrichtigung ausschalten" : "Bei Spielen benachrichtigen"}
                        onClick={() => status.onPush(player.id, !push)}>
                    <i className={push ? "pi pi-star-fill" : "pi pi-star"} aria-hidden="true"/>
                </button>
            }
        </span>
    }

    // auf Handy und Tablet Kacheln statt Tabelle; es wird nur eines von beiden gerendert, damit die Spielersuche nichts doppelt findet
    const getKacheln = () => {
        return <ol className="dhpt-tn-kacheln">
            {teilnehmer.map((player, index) => {
                const gruppe = gruppen ? getGruppe(player.id) : undefined;
                return <li key={player.id} className="dhpt-tn-kachel">
                    <span className="dhpt-tab-platz-zahl dhpt-tn-nummer">{index + 1}.</span>
                    <span className="dhpt-tn-kachel-name">{player.name}</span>
                    {player.vereinsname && <span className="dhpt-tn-verein">{player.vereinsname}</span>}
                    {gruppe && <span className="dhpt-tn-gruppe-chip">Gruppe {gruppe}</span>}
                    {mitStatus && <span className="dhpt-tn-kachel-status">{getStatus(player)}</span>}
                </li>
            })}
        </ol>
    }

    const getInhalt = () => {
        if (teilnehmer.length === 0) {
            return <p className="dhpt-hinweis">Es sind noch keine Teilnehmer vorhanden.</p>
        }
        if (schmal) {
            return getKacheln();
        }
        return getTabelle();
    }

    const getTabelle = () => {
        return <div className="dhpt-tn-scroll">
            <table className="dhpt-tab">
                <caption className="dhpt-st-versteckt">{titel}</caption>
                <thead>
                <tr>
                    <th scope="col" className="dhpt-tab-platz">#</th>
                    <th scope="col">Name</th>
                    {gruppen && <th scope="col" className="dhpt-tn-gruppe">Gruppe</th>}
                    {mitStatus && <th scope="col" className="dhpt-tab-zahl">Status</th>}
                </tr>
                </thead>
                <tbody>
                {teilnehmer.map((player, index) => {
                    const gruppe = gruppen ? getGruppe(player.id) : undefined;
                    return <tr key={player.id} className="dhpt-tab-zeile">
                        <td className="dhpt-tab-platz"><span className="dhpt-tab-platz-zahl">{index + 1}.</span></td>
                        <td>
                            <span className="dhpt-tab-name">{player.name}</span>
                            {player.vereinsname && <span className="dhpt-tn-verein">{player.vereinsname}</span>}
                        </td>
                        {gruppen && <td className="dhpt-tn-gruppe">{gruppe ? "Gruppe " + gruppe : ""}</td>}
                        {mitStatus && <td className="dhpt-tab-zahl">{getStatus(player)}</td>}
                    </tr>
                })}
                </tbody>
            </table>
        </div>
    }

    return <section className="dhpt-karte dhpt-tn-karte">
        <h3 className="dhpt-karte-titel"><span>{titel}</span>{zusatz && <span className="dhpt-karte-zusatz">{zusatz}</span>}</h3>
        {getInhalt()}
    </section>
}
